import axios from "axios";
import authHeader from '../authheader'

const SOSLOOKUP = process.env.REACT_APP_APIURL + "/api/SosLookup";

const getSosLookupData = async (nameSearch) => {
    return axios.get(`${SOSLOOKUP}/soslookup`, { headers: authHeader(), params: { nameSearch } })
}
const getSosEntityData = async (entityNumber, entityTypeId) => {
    return axios.get(`${SOSLOOKUP}/sosentitylookup`, { headers: authHeader(), params: { entityNumber, entityTypeId } })
}
export default {
    getSosLookupData,
    getSosEntityData
}